<template>
  <div class="page-container">
    <!-- Content Wrapper START -->
    <div class="main-content">
      <div class="page-header">
        <h2 class="header-title">Queries</h2>
        <div class="header-sub-title">
          <nav class="breadcrumb breadcrumb-dash">
            <router-link :to="`/`" class="breadcrumb-item">
              <i class="anticon anticon-home m-r-5"></i>Home
            </router-link>
            <span class="breadcrumb-item active">Queries</span>
          </nav>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <div class="">
            <section v-if="!isLoading">
              <div class="row">
                <div class="col-lg-12 add-form">
                  <input class="form-control datatable_search" @keyup="searchDatatable" placeholder="Search..."/>
                </div>
              </div>
              <table class="dataTable table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Name</th>
                    <th>Subject</th>
                    <th>Email</th>
                    <th>Location</th>
                    <th>Message</th>
                    <th>Submitted On</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="query in queries" :key="query.id">
                    <td>{{query.id}}</td>
                    <td>{{query.name}}</td>
                    <td>{{query.subject}}</td>
                    <td>{{query.email}}</td>
                    <td>{{query.location}}</td>
                    <td>{{query.message}}</td>
                    <td>
                      <span style="display:none;">
                        {{new Date(query.created_at).getTime()}}
                      </span>
                      {{query.created_at}}
                    </td>
                    <td>
                      <i class="fa fa-trash fa-icons" @click="deleteQuery(query.id)" aria-hidden="true"></i>
                    </td>
                  </tr>
                </tbody>
                <tfoot></tfoot>
              </table>
            </section>
            <div class="main-loader" v-else>
              <MainLoader></MainLoader>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Query from '@/models/Query'
export default {
  name: 'Queries',
  data () {
    return {
      isLoading: false,
      datatable: null,
      queries: []
    }
  },
  mounted () {
    let dataTableScript = document.createElement('script')
    dataTableScript.setAttribute('src', 'https://cdn.datatables.net/1.10.22/js/jquery.dataTables.min.js')
    document.head.appendChild(dataTableScript)
    this.fetchAllQueries()
  },
  methods: {
    fetchAllQueries () {
      this.queries = []
      this.isLoading = true
      this.$store.dispatch('fetchAllQueries')
        .then((result) => {
          result.data.queries.forEach(query => {
            this.queries.push(new Query(query))
          })
          this.isLoading = false
          setTimeout(() => this.initDatatables(), 100)
        })
        .catch((err) => this.$helper.catchHandler(err))
    },
    deleteQuery (id) {
      this.$confirm(
        {
          message: `Are you sure you want to delete this query?`,
          button: { no: 'No', yes: 'Yes' },
          callback: confirm => {
            if (confirm) {
              this.$store.dispatch('deleteQuery', id)
                .then((result) => {
                  this.$toast.success(result.data.message)
                  this.fetchAllQueries()
                })
                .catch((err) => this.$toast.error(err.response.data.message))
            }
          }
        }
      )
    },
    searchDatatable (e) {
      this.datatable.search(e.target.value).draw()
    },
    initDatatables () {
      this.datatable = $('table').DataTable({
        destroy: true,
        stateSave: true,
        pagingType: 'full_numbers',
        columnDefs: [{
          targets: 7,
          'orderable': false
        }],
        stateSaveCallback: function (settings, data) {
          localStorage.setItem('DataTables_accounts_page', JSON.stringify(data))
        },
        stateLoadCallback: function (settings) {
          return JSON.parse(localStorage.getItem('DataTables_accounts_page'))
        },
        drawCallback: function (settings) {
          $('.previous').html("<img src='/static/images/left_arrow.svg'>")
          $('.next').html("<img src='/static/images/right_arrow.svg'>")
          $('.first').addClass('d-inline')
          $('.first').html("<img src='/static/images/left_arrow.svg'><img src='/static/images/left_arrow.svg'>")
          $('.last').addClass('d-inline')
          $('.last').html("<img src='/static/images/right_arrow.svg'><img src='/static/images/right_arrow.svg'>")
        }
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Queries.vue